import clsx from 'clsx';

export type DividerProps = { className?: string };

export const Divider = ({ className }: DividerProps) => {
  return (
    <div
      className={clsx(
        'w-full h-0 rounded-full',
        'border border-solid',
        'border-blue-desaturated/60',
        className
      )}
    ></div>
  );
};
